import { Action, IEventHandler, ofType } from '@bees-lite-web/core';
import { AnalyticsBrowser } from '@segment/analytics-next';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { sendAnalytics } from '../../../utils/sendAnalytics';
import { ActionsUrl } from '../../core/actionUrl.shortcut';

export interface ILaunchURLParams {
  url: string;
  analyticsData?: any;
}

export class ActionsLaunchURLHandler
  implements IEventHandler<ILaunchURLParams>
{
  constructor(private analytics: AnalyticsBrowser | undefined) {}

  handler(
    source: Observable<Action<'action', ILaunchURLParams>>
  ): Observable<Action<'action', ILaunchURLParams>> {
    return source.pipe(
      ofType((action) => action.url === ActionsUrl.LAUNCH_URL),
      tap(async (e) => {
        if (e.parameters && this.analytics) {
          await sendAnalytics(e.parameters, this.analytics);

          window.open(e.parameters.url, '_blank');
        }
      })
    );
  }
}
